import { handleRequest } from "../utilities/requestHandler";

export const getCasesBySite = (selectedSite) =>
    handleRequest("post", "/services/cases", {
        selectedSite: selectedSite,
    });

export const getWorkordersBySite = (selectedSite) =>
    handleRequest("post", "/services/workorders", {
        selectedSite: selectedSite,
    });


export const getWorkorderReport = (woNumber) =>
    handleRequest("post", "/services/workorders/report", {
        wo_number: woNumber,
    });